import React, { memo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { getMessage } from 'util/locale';
import { DatePicker } from '@tcc/crate';
import moment from 'moment';

// HUGE TECH DEBT => MOMENT
export const PlantingDateInput = memo(function PlantingDateInput() {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name="plannedPlantingDate"
      defaultValue={moment().format('YYYY-MM-DD')}
      render={({ field }) => (
        <DatePicker
          label={getMessage('title-text__planting-date')}
          className="bulk-fvss-script-generation-planting-date-picker"
          moment={moment}
          maxDate={moment().add(1, 'years').toISOString()}
          selected={field.value}
          onChangeDate={(newDate) => {
            const formattedDate = moment(newDate).format('YYYY-MM-DD');
            field.onChange(formattedDate);
          }}
          testId="planned-planting-date-picker"
        />
      )}
    />
  );
});
